import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "texture-list" };
import TextureList from "@/binaplan/components/handbooks/TextureList.vue";
import TitlePage from "@/binaplan/components/layouts/TitlePageContainer.vue";
import { ref } from "vue";
import Lang from "@/plugins/Lang";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ListView',
    setup(__props) {
        const lang = ref({
            title_page: Lang.get("admin-surface.textures_title_page"),
            link_add: Lang.get("admin-surface.textures_link_add"),
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(TitlePage, {
                    "back-button": lang.value.link_add,
                    "back-url": "/admin/textures/create",
                    "title-page": lang.value.title_page
                }, null, 8, ["back-button", "title-page"]),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(TextureList)
                ])
            ]));
        };
    }
});
